import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=c8cf9430&scoped=true"
import script from "./AddressInput.vue?vue&type=script&lang=js"
export * from "./AddressInput.vue?vue&type=script&lang=js"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=c8cf9430&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cf9430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8cf9430')) {
      api.createRecord('c8cf9430', component.options)
    } else {
      api.reload('c8cf9430', component.options)
    }
    module.hot.accept("./AddressInput.vue?vue&type=template&id=c8cf9430&scoped=true", function () {
      api.rerender('c8cf9430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/MoreAboutYourself/AddressInput.vue"
export default component.exports